interface IBreadcrumbContainer {
  children: JSX.Element[];
}

const BreadcrumbContainer = ({
  children,
}: IBreadcrumbContainer): JSX.Element => {
  return (
    <nav
      className={`no-scrollbar h-[1.1875rem] overflow-y-scroll desktop:w-fit desktop:overflow-hidden`}
      aria-label="breadcrumb"
    >
      <ol className="flex flex-row gap-2">{children}</ol>
    </nav>
  );
};

export default BreadcrumbContainer;
